function resolveEnv(host) {
	const environments = ['dev', 'test', 'uat', 'pre-prod'];
	const hostParts = host.split('.');

	if (hostParts.some(part => !/^[a-zA-Z0-9-_]+$/.test(part))) {
		return null;
	}

	const envMatches = hostParts.filter(part =>
		environments.some(env => part === env)
	);

	if (envMatches.length > 1) {
		return null;
	}

	for (const env of environments) {
		const envPart = hostParts.find(part => part === env);
		if (envPart) {
			return env;
		}
	}

	const hasInvalidEnvPart = hostParts.some(part =>
		environments.some(env =>
			(part.toLowerCase().includes(env) || env.includes(part.toLowerCase())) &&
			part !== env
		)
	);

	return hasInvalidEnvPart ? null : 'prod';
}

function resolveDex(host) {
	if (host.includes('sgbuildex')) return 'sgbuildex';
	if (host.includes('sghealthdex')) return 'sghealthdex';
	if (host.includes('sgtradex.io') || host.includes('afa-cdi.com')) return 'sgtradex';
	return null;
}

export function getEnvAndDex() {
	const host = window.location.hostname;

	let env, dex;

	if (host === 'localhost') {
		env = process.env.REACT_APP_ENV;
		dex = process.env.REACT_APP_DEX_ENV;
	} else {
		env = resolveEnv(host);
		dex = resolveDex(host);
	}

	if (!env || !dex) {
		throw new Error(`Unable to determine env or dex from hostname: ${host}`);
	}

	return { env, dex };
}
